import React from 'react';

export const pageContext = React
  .createContext
  /* optional default value */
  ();
